import { configureStore } from '@reduxjs/toolkit';
import strategyReducer from '../Reducers/strategyReducers'
import transactionReducer from "../Reducers/transactionReducer";
import userStatusReducer from "../Reducers/userStatusReducer";
import authReducer from '../Reducers/authReducer';
export const store = configureStore({
  reducer: {
   strategy:strategyReducer,
   transaction: transactionReducer,
   userStatus: userStatusReducer,
     user: authReducer
  },
});
